module.exports = __webpack_public_path__ + "img/4_57.49463294.png";